import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '@/components/ui/button';
import { Calendar, Clock, Users, ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const DemoSchedule = () => {
  const navigate = useNavigate();

  const demoTypes = [
    {
      icon: <Users className="w-6 h-6 text-primary" />,
      title: "Group Demo",
      description: "Perfect for healthcare teams and organizations",
      duration: "45 minutes"
    },
    {
      icon: <Calendar className="w-6 h-6 text-primary" />,
      title: "Personal Demo",
      description: "One-on-one walkthrough of the platform",
      duration: "30 minutes"
    }
  ];

  const timeSlots = [
    "9:00 AM EST",
    "11:00 AM EST",
    "2:00 PM EST",
    "4:00 PM EST"
  ];

  return (
    <div className="min-h-screen py-20">
      <motion.div 
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="max-w-4xl mx-auto px-4"
      >
        <h1 className="text-4xl font-bold text-center mb-8">Schedule a Demo</h1>
        <p className="text-xl text-gray-600 text-center mb-12">
          See CareTrackAI in action with a personalized demo
        </p>

        <div className="grid md:grid-cols-2 gap-8 mb-12">
          {demoTypes.map((type, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
              className="bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-shadow"
            >
              <div className="flex items-center gap-4 mb-4">
                <div className="p-3 bg-primary/10 rounded-lg">
                  {type.icon}
                </div>
                <div>
                  <h3 className="text-xl font-semibold">{type.title}</h3>
                  <p className="text-gray-600">{type.description}</p>
                </div>
              </div>
              <div className="flex items-center gap-2 text-sm text-gray-500">
                <Clock className="w-4 h-4" />
                <span>{type.duration}</span>
              </div>
            </motion.div>
          ))}
        </div>

        <div className="bg-white p-8 rounded-xl shadow-lg mb-12">
          <h2 className="text-2xl font-semibold mb-6">Available Time Slots</h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {timeSlots.map((slot, index) => (
              <Button
                key={index}
                variant="outline"
                className="w-full justify-center"
              >
                {slot}
              </Button>
            ))}
          </div>
        </div>

        <div className="text-center">
          <Button 
            size="lg"
            className="px-8 py-6"
            onClick={() => navigate('/contact-sales')}
          >
            Request Custom Time
            <ArrowRight className="ml-2 w-4 h-4" />
          </Button>
        </div>
      </motion.div>
    </div>
  );
};

export default DemoSchedule;